<template>
  <div class="page-template">
    <div class="page-swiper">
      <van-search v-model="value" show-action shape="round" @search="_getQuery" placeholder="请输入手机号/商户订单号">
        <template #action>
          <div @click="_getQuery" style="font-size:.28rem">查询</div>
        </template>
      </van-search>
    </div>

    <!-- <div class="page-menu">
      <div class="menu-list active">全部</div>
      <div class="menu-list">待付款</div>
      <div class="menu-list">待收货</div>
      <div class="menu-list">待评价</div>
    </div> -->
    <div v-if="shopList.length > 0" style="margin-bottom:1rem">
      <div class="page-goods" v-for="item in shopList" :key="item.id">
        <div class="title">
          <div class="trade">
            <van-icon name="send-gift" color="#ee0a24" size="0.32rem"
              style="vertical-align: middle; margin-bottom: 0.08rem" />
            {{ item.out_trade_no }}
          </div>
          <div class="status" v-if="item.status == 0">待付款</div>
          <div class="status" style="color: green" v-if="item.status == 2">
            已完成
          </div>
        </div>
        <div class="content">
          <img :src="item.goods_front" alt="GEEK" @click="$router.push('/m/details/'+item.goods_id)" />
          <div class="name" @click="$router.push('/m/details/'+item.goods_id)">{{ item.goods_name }}</div>
          <div class="norms" @click="$router.push('/m/details/'+item.goods_id)">{{ item.norms_name }}</div>
          <div class="price">
            <em style="font-size: 0.26rem">￥</em>
            {{ item.unit_price }}
          </div>
          <span class="num"> ×{{ item.count }}</span>
          <span class="time">{{item.endTime}}</span>
          <div class="money">
            总价:
            <em style="font-size: 0.26rem">￥</em>
            {{ item.money }}
          </div>
        </div>
        <div class="btn">
          <van-button type="default" round size="small" v-if="item.status == 0">立即支付</van-button>
          <van-button type="info" round plain size="small" v-if="item.status == 2" @click="remarks(item)">商家备注
          </van-button>
          <van-button type="danger" round plain size="small" v-if="item.status == 2" @click="read(item)">
            查看{{ item.goods_category }}</van-button>
          <van-button type="danger" round plain size="small" v-if="item.status == 2" v-clipboard:copy="item.content"
            v-clipboard:success="onCopy" v-clipboard:error="onError">复制{{ item.goods_category }}</van-button>
        </div>
      </div>
    </div>
    <Empty :text="'暂无记录'" v-else></Empty>

    <Menu></Menu>
    <van-dialog v-model="show" show-cancel-button>
      <div class="show-main">
      <p v-for="item in content" :key="item">{{item}}</p>

      </div>
    </van-dialog>
  </div>
</template>

<script>
  import {
    getQuery,
    getSystem
  } from "@/api/index";
  import cookie from "@/utils/store/cookie";

  import {
    Dialog,
    Toast
  } from "vant";

  export default {
    data() {
      return {
        basic: {},
        value: "",
        show:false,
        shopList: [],
        content:[]
      };
    },
    created() {
      if (cookie.get('phone')) {
        this.value = cookie.get('phone')
        this._getQuery()
      }
    },
    methods: {
      // 查询订单
      _getQuery() {
        Toast.loading({
          message: "查询中...",
          forbidClick: true,
          duration: 0
        });
        getQuery({
          value: this.value,
        }).then((res) => {
          Toast.clear()
          this.shopList = res.data;
        });
      },
      onCopy(e) {
        Toast.success("复制成功");
      },
      onError(e) {
        Toast.fail("复制失败");
      },
      // 商家备注
      remarks(row) {
        Dialog.confirm({
            message: row.remarks ? row.remarks : '暂无备注',
          })
          .then(() => {})
          .catch(() => {});
      },
      // 查看卡密
      read(row) {
        this.content = row.content
        this.show = true
      },
      // 获取设置
      _getSystem() {
        getSystem().then((res) => {
          this.basic = res.data;
        });
      },

    },
  };
</script>

<style lang="less" scoped>
  @import "../../../../assets/css/clean.css";
  @deep: ~">>>";

  .page-template {
    background-color: rgb(245, 246, 247);
    min-height: 100vh;
    position: relative;
    overflow: hidden;

    .page-swiper {
      .van-cell {
        font-size: .28rem;
        line-height: .28rem;
      }

      .van-search__action {
        font-size: .28rem;
        line-height: .64rem;
      }

      @{deep}.van-icon {
        font-size: .32rem;
        margin-top: .03rem;
      }

      @{deep}.van-field__control {
        font-size: .28rem;
      }
    }

    .page-head {
      height: 1rem;
      background: linear-gradient(to right, #ff6034, #ee0a24);
      display: block;
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      z-index: 1000;
      padding: 0 10px;

      .page-name {
        display: inline-block;
        color: #ffffff;
        font-weight: normal;
        line-height: 1rem;
        margin: 0;
        padding: 0;
        font-size: 0.4rem;
      }

      .page-search {
        float: left;
        margin-top: 0.25rem;
        height: 0.5rem;

        .van-icon {
          margin: 0 0.1rem;
        }
      }

      .page-btn {
        float: right;
        margin-top: 0.25rem;
        height: 0.5rem;

        .van-icon {
          margin: 0 0.1rem;
        }
      }
    }

    .page-menu {
      height: 0.8rem;
      padding: 0 0.2rem;
      background: #ffffff;
      display: flex;
      justify-content: space-around;

      .menu-list {
        font-size: 0.32rem;
        padding-top: 0.1rem;
      }

      .active {
        font-size: 0.34rem;
        color: #ff6034;
        font-weight: 600;
      }
    }

    .page-goods {
      background: #ffffff;
      padding: 0 0.2rem;
      margin: 0.2rem 0.1rem;
      border-radius: 0.2rem;
      padding-bottom: 0.1rem;

      .title {
        height: 0.8rem;
        line-height: 0.8rem;

        .trade {
          float: left;
          font-size: 0.32rem;
          color: black;
        }

        .status {
          float: right;
          font-size: 0.30rem;
          color: #ff6034;
        }
      }

      .content {
        position: relative;

        img {
          display: inline-block;
          width: 1.8rem;
          height: 1.8rem;
          border-radius: 0.2rem;
        }

        .name {
          position: absolute;
          left: 2rem;
          top: 0.05rem;
          font-size: 0.32rem;
          color: black;
          width: 50%;
          font-weight: 600;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          /* 行数 */
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .norms {
          position: absolute;
          left: 2rem;
          top: 0.7rem;
          font-size: 0.3rem;
          color: #999;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          /* 行数 */
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .price {
          position: absolute;
          right: 0.1rem;
          top: 0.05rem;
          font-size: 0.36rem;
          color: black;
        }

        .num {
          position: absolute;
          right: 0.1rem;
          top: 0.7rem;
          font-size: 0.3rem;
          color: #999;
        }

        .time {
          position: absolute;
          left: 2rem;
          top: 1.4rem;
          font-size: 0.25rem;
          // color: black;
        }

        .money {
          position: absolute;
          right: 0.1rem;
          top: 1.3rem;
          font-size: 0.34rem;
          color: black;
        }
      }

      .btn {
        margin: 0.1rem 0;
        text-align: right;

        button {
          padding: 0 .3rem;
          margin-left: 0.2rem;
        }

        .van-button {
          height: .64rem;
          font-size: .24rem;

          @{deep}.van-button__text {
            font-size: .28rem;
          }
        }
      }
    }


    .msgtop {
      margin: 5px;
      border: 1px solid #ffffff;
    }
    .show-main{
      padding: .4rem;
      max-height: 50vh;
      overflow-y: scroll;
    }
  }
</style>